export default "__VITE_ASSET__552edc3c__"